export enum ECalculationStatus {
  NOT_RUN,
  WAITING,
  SUCCESS,
  Failure
}




// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/components/calculation-editor/e-calculation-status.ts